// removed by extract-text-webpack-plugin
module.exports = {"content":"content___1Wqrn","closeIcon":"closeIcon___lEzmR","header":"header___1SFS_","inputTitle":"inputTitle___v0ksa","required":"required___2QuyC","tagContainer":"tagContainer___aLUru","errorTxt":"errorTxt___2p6lI","tagDropdown":"tagDropdown___2cZzw","searchTag":"searchTag___3YeUF","upload":"upload___3uKNi","searchTagContainer":"searchTagContainer___lCCvF","btnGroup":"btnGroup___7SJlX","text":"text___AMbQL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DeleteModel/DeleteModel.module.css
// module id = 213
// module chunks = 0